export const REQUIRED_FIELD_MESSAGE = "This field is required";
export const SHORT_FIELD_MESSAGE = (len: number) => `This field must be at least ${len} characters`;
export const INVALID_FIELD_MESSAGE = (fieldName: string) => `Please enter a valid ${fieldName}`;

